<template>
  <div class="pdfBox">
    <div v-if="isClose" class="close-btn" @click.capture='close()'>
      关闭预览
    </div>
    <div id="previewPdf"></div>
  </div>
</template>
<script>
import pdfh5 from 'pdfh5';
import 'pdfh5/css/pdfh5.css'
export default {
  props: {
    url: {
      type: String,
      required: ''
    },
    isClose: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      pdfh5: null,
    }
  },
  mounted() {
    this.openPdf();
  },
  methods: {
    close() {
      this.$emit('close')
    },
    openPdf() {     //url：PDF文件地址
      this.pdfh5 = new pdfh5('#previewPdf', {
        // pdfurl: this.url,
        data: this.url,
      });
      this.pdfh5.on('success', () => {
        console.log('pdf渲染成功');
      });
    }
  }
}
</script>
<style lang="less" scoped>
.pdfBox {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  overflow: hidden;
  z-index: 99;
  width: 100%;
  color: red;

  #previewPdf {
    height: 100vh;
  }
}

.close-btn {
  position: fixed;
  top: .2rem;
  right: .2rem;
  z-index: 900;
  font-size: .16rem;
  padding: 0.1rem;
  text-align: center;
  border-radius: 0.15rem;
  // background-color: rgba(0,0,255, 0.6);
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
}

.pdfBox #previewPdf .textLayer .textLayerItem {
  font-size: 50px;
}

.pdfjs .backTop {
  background-color: none !important;
}
</style>